// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Calendar_diet_overlay__2Mw9b","container":"Calendar_diet_container__Lw64E","button":"Calendar_diet_button__OCcvZ","icon":"Calendar_diet_icon__3PLJf"};